import React from 'react';
import { ChannelTypes } from '../../shared/types';
import { ExtendedTheme, TextBlock, TextLabel, UserInterfaceLock } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	channelType: {
		display: 'flex',
		gap: theme.spacing(1),
		alignItems: 'center'
	}
}));

interface ChannelLabelProps {
    type: ChannelTypes;
    withDescription?: boolean;
}
export const ChannelLabel = ({type, withDescription}: ChannelLabelProps) => {
	const classes = useStyles();
	const styleName = type === ChannelTypes.premium ? 'info' : undefined;
	const label = type === ChannelTypes.freeClosed ? 'free - closed' : type === ChannelTypes.freeOpen ? 'free - open' : 'premium';
	return <div className={classes.channelType}>
		<TextLabel styleName={styleName} label={label} />
		{type === ChannelTypes.freeClosed && <UserInterfaceLock />}
		{withDescription && <TextBlock>{
			type === ChannelTypes.premium
				? <>Insights users have to pay to become subscribers and gain full access to the channel.</>
				: type === ChannelTypes.freeClosed
					? <>This channel is <strong>closed</strong>. Insights users have to request access to become subscribers and gain full access to the channel.</>
					: <>This channel is <strong>open to everyone</strong>. All Insights user can access the channel and read your articles.</>

		}</TextBlock>}
	</div>
}